import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.cleanupBackdrops()
    this.modal = Modal.getOrCreateInstance(this.element)

    this.modal.show()
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
      this.modal.dispose()
    }

    this.cleanupBackdrops()
  }

  cleanupBackdrops() {
    // モーダル再描画時のbackdrop積み上がりを防止
    document.querySelectorAll(".modal-backdrop").forEach((element) => element.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("padding-right")
  }
}
